import axios from 'axios';

const aadhaarAxiosInstance = axios.create({
  // baseURL: 'https://sandbox.surepass.io',
  baseURL: process.env.VUE_APP_BASE_SUREPASS_API_URL,
  timeout: 30000,
});

aadhaarAxiosInstance.interceptors.request.use((config) => {
  // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcyNDc1NzMwNSwianRpIjoiYmU2OGFjYTgtMTIzYy00NDYyLWEwZmUtMjMyMjhiYTc1MmI1IiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2Lm1vdGhlcnNvbl9jb25zb2xlQHN1cmVwYXNzLmlvIiwibmJmIjoxNzI0NzU3MzA1LCJleHAiOjE3MjczNDkzMDUsImVtYWlsIjoibW90aGVyc29uX2NvbnNvbGVAc3VyZXBhc3MuaW8iLCJ0ZW5hbnRfaWQiOiJtYWluIiwidXNlcl9jbGFpbXMiOnsic2NvcGVzIjpbInVzZXIiXX19.-obGyCe-Fl2slJovMTl-LlCT5eMSIsOmqfXkUqyM9Fk'; // Replace with your token retrieval logic
  const token = process.env.VUE_APP_SUREPASS_API_TOKEN; // Replace with your token retrieval logic
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default {
  install: (app) => {
    app.config.globalProperties.$aadhar_axios = aadhaarAxiosInstance ;
    app.provide('aadhar_axios', aadhaarAxiosInstance );
  },
};
